export const containerEntrega = {
    marginBottom: '8px',
    background: '#ffffff',
    borderRadius: '5px',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.322)'
}

export const sxColum = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '1px 10px'
}

export const sxTypografy = {
    color: 'black',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word'
}

export const sxTypografySemDest = {
    ...sxTypografy,
    color: '#a1a1a1'
}
